import { getLiveClaimFeedTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";

const LIVE_CLAIM_FEED_EVENT_TYPES = {
  REQUEST_DATA: "requestData",
  UPDATE_LIVE_CLAIM_FEED_DATA: "updateLiveClaimFeedData",
  VALIDATION: "validation",
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
};

const decodeFromLiveClaimFeedData = element => {
  if (!element) return {};

  return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
};

const editLiveClaimFeedConfig = (editor, shortcodeWrapper) => {
  let currentData = decodeFromLiveClaimFeedData(shortcodeWrapper.getAttribute("data-live-claim-feed-data"));
  let isValid = null;

  const liveClaimFeedWindow = editor.windowManager.openUrl({
    title: "Live Claim Feed",
    url: "/live-claim-feed-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        liveClaimFeedWindow.sendMessage({
          type: LIVE_CLAIM_FEED_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute(
        "data-live-claim-feed-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === LIVE_CLAIM_FEED_EVENT_TYPES.REQUEST_DATA) {
        sendData();
      }

      if (message.mceAction === LIVE_CLAIM_FEED_EVENT_TYPES.SEND_DATA) {
        const { data } = message.data;
        if (data === "undefined") {
          // Handle case where user exits without saving
          currentData = null;
        } else {
          currentData = data;
          isValid = true;
        }
      }

      if (message.mceAction === LIVE_CLAIM_FEED_EVENT_TYPES.UPDATE_LIVE_CLAIM_FEED_DATA && message.data) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === LIVE_CLAIM_FEED_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 800,
    height: 700,
  });

  const sendData = () => {
    let existData = decodeFromLiveClaimFeedData(shortcodeWrapper.getAttribute("data-live-claim-feed-data"));
    liveClaimFeedWindow.sendMessage({
      type: LIVE_CLAIM_FEED_EVENT_TYPES.SEND_DATA,
      data: existData,
    });
  };
};

const liveClaimFeedConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const liveClaimFeedWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Live Claim Feed",
    url: "/live-claim-feed-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        liveClaimFeedWindow.sendMessage({
          type: LIVE_CLAIM_FEED_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getLiveClaimFeedTemplate(),
        "live-claim-feed",
      );

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(
        "data-live-claim-feed-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === LIVE_CLAIM_FEED_EVENT_TYPES.SEND_DATA) {
        const { data } = message.data;
        if (data === "undefined") {
          currentData = null;
        } else {
          currentData = data;
          isValid = true;
        }
      }

      if (message.mceAction === LIVE_CLAIM_FEED_EVENT_TYPES.UPDATE_LIVE_CLAIM_FEED_DATA) {
        currentData = message.data;
        isValid = true;

        return;
      }

      if (message.mceAction === LIVE_CLAIM_FEED_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 800,
    height: 700,
  });
};

export { liveClaimFeedConfig, editLiveClaimFeedConfig, LIVE_CLAIM_FEED_EVENT_TYPES };
